/*
RELEASE MODE
0 : DEVELOPMENT
1 : DEV
2 : STG RELEASE
3 : PROD RELEASE
4 : BCP
*/
const _releaseMode = 4;

//version
const _releaseVersionDev = 'β1.7.2.0'

const _releaseVersionProd = '1.7.2'

export function releaseMode() {
	return _releaseMode;
}

export function releaseVersion() {
	switch (_releaseMode) {
		case 0:
		case 1:
		case 2:
			return _releaseVersionDev;
		default:
			return _releaseVersionProd;
	}
}

// Color Settings
const _baseColorPrimary = "rgb(64,186,208)";
const _baseColorSecondary = "rgb(64,186,208)";
const _baseColorPrimaryHover = "rgb(44, 130, 145)";

const _successColor = "#4caf50";
const _errorColor = "#f44336";
const _warningColor = "#ff9800";
const _infoColor = "#2196f3";

export function getPrimaryColor() {
	return _baseColorPrimary;
}

export function getSecondaryColor() {
	return _baseColorSecondary;
}

export function getPrimaryColorHover() {
	return _baseColorPrimaryHover;
}

export function getSuccessColor() {
	return _successColor;
}

export function getErrorColor() {
	return _errorColor;
}

export function getWarningColor() {
	return _warningColor;
}

export function getInfoColor() {
	return _infoColor;
}



// WEBPACK FOOTER //
// ./src/common/const.js